var map = {
	"./black_c.png": 6096,
	"./black_p.png": 6134,
	"./black_s2.png": 942,
	"./boots.png": 5639,
	"./coat.png": 6468,
	"./jumper.png": 3606,
	"./orange_t.png": 976,
	"./pants.png": 2177,
	"./pattern_b.png": 1991,
	"./pink_c.png": 4307,
	"./red_c.png": 7699,
	"./sneakers.png": 7538,
	"./tshirt.png": 2189,
	"./white_s2.png": 5091,
	"./white_t4.png": 1916,
	"./yellow_j.png": 9121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1458;